import { GeneralRoutes } from './general.routes';
import { MyAccountRoutes } from './my-account.routes';

export const ClientRoutes = [...GeneralRoutes, MyAccountRoutes];
